namespace $ { $mol_style_attach( "mpds/visavis/plot/pie/pie.view.css",
 "[mpds_visavis_plot_pie] g.slice {\n\tcursor: pointer;\n}\n\n[mpds_visavis_plot_pie] g.slicetext {\n\tpointer-events: none;\n}\n"
) }